import auth from "../middleware/auth";
import guest from "../middleware/guest";
import Vue from "vue";

const routes = [
  {
    name: "login",
    path: "/login",
    meta: { middleware: guest },
    component: () => import("@/views/auth/Login"),
  },
  {
    path: "/",
    component: () => import("@/views/dashboard/MainLayout.vue"),
    meta: { middleware: auth },
    children: [
      // With Permission
      // Dashboard
      ...(Vue.prototype.$admin.hasAccessTo("dashboard.list")
        ? [
            {
              name: "dashboard",
              path: "/",
              meta: { middleware: auth },
              component: () => import("@/views/modules/dashboard/Index.vue"),
            },
          ]
        : []),
      // ORKO AI INSIGHTS
      ...(Vue.prototype.$admin.hasAccessTo("dashboard.list")
        ? [
            {
              name: "AI_insights",
              path: "/ORKO-AI-Insights",
              meta: { middleware: auth },
              component: () => import("@/views/modules/ai-insights/Index.vue"),
            },
            // {
            //   name: "chat",
            //   path: "/ORKO-AI-Insights/chat",
            //   meta: { middleware: auth, parent_name: ["AI_insights"] },
            //   component: () =>
            //     import("@/views/modules/ai-insights/sub-screen/AI-Chat.vue"),
            // },
          ]
        : []),
      // ORKO AI INSIGHTS

      // live tracking
      ...(Vue.prototype.$admin.hasAccessTo("live-tracking.list")
        ? [
            {
              name: "live_tracking",
              path: "/live-tracking",
              meta: { middleware: auth },
              component: () => import("@/views/modules/tracking/Index.vue"),
            },
          ]
        : []),

      // GeoFence
      ...(Vue.prototype.$admin.hasAccessTo("live-tracking.list")
        ? [
            {
              name: "geofence",
              path: "/geofence",
              meta: { middleware: auth },
              component: () => import("@/views/modules/geofence/Index.vue"),
            },
            {
              name: "geofence_add",
              path: "/geofence/add",
              meta: { middleware: auth, parent_name: ["geofence"] },
              component: () =>
                import("@/views/modules/geofence/sub-screen/AddGeofence.vue"),
            },
            {
              name: "geofence_edit",
              path: "/geofence-edit/:id",
              meta: { middleware: auth, parent_name: ["geofence"] },
              component: () =>
                import("@/views/modules/geofence/sub-screen/EditGeofence.vue"),
            },
          ]
        : []),
      // Geofence

      //Modules Screen:
      // Make
      ...(Vue.prototype.$admin.hasAccessTo("md-makes.list")
        ? [
            {
              name: "md_makes",
              path: "/md-makes",
              meta: { middleware: auth },
              component: () => import("@/views/modules/md-makes/Index.vue"),
            },
          ]
        : []),
      // Models
      ...(Vue.prototype.$admin.hasAccessTo("md-models.list")
        ? [
            {
              name: "md_models",
              path: "/md-models",
              meta: { middleware: auth },
              component: () => import("@/views/modules/md-models/Index"),
            },
          ]
        : []),
      // Vehicle
      ...(Vue.prototype.$admin.hasAccessTo("vehicles.list")
        ? [
            {
              name: "vehicles",
              path: "/vehicles",
              meta: { middleware: auth },
              component: () => import("@/views/modules/vehicles/Index.vue"),
            },
          ]
        : []),
      // Vehicle Telematic
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-telematics.list")
        ? [
            {
              name: "vehicle_telematics",
              path: "/vehicle-telematics",
              meta: { middleware: auth },
              component: () => import("@/views/modules/telematics/Index.vue"),
            },
          ]
        : []),
      // Detail
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-telematics-detail.list")
        ? [
            {
              name: "telematic_details",
              path: "/vehicle-telematics/:vehicle_id",
              meta: { middleware: auth, parent_name: ["vehicle_telematics"] },
              component: () =>
                import("@/views/modules/telematics/sub-screen/Detail.vue"),
              // component: () => {
              //   const authUser = JSON.parse(localStorage.getItem("user"));
              //   if (authUser.isAdmin) {
              //     return import(
              //       "@/views/modules/telematics/sub-screen/Detail.vue"
              //     );
              //   } else {
              //     return import(
              //       "@/views/modules/telematics/sub-screen/OEMDetail.vue"
              //     );
              //   }
              // },
            },
          ]
        : []),
      // Trip Listing
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-trips.list")
        ? [
            {
              name: "trips",
              path: "/trips",
              meta: { middleware: auth },
              component: () => import("@/views/modules/trips/Index"),
            },
          ]
        : []),
      // Single Trip List
      ...(Vue.prototype.$admin.hasAccessTo("single-vehicle-trips.list")
        ? [
            {
              name: "trip-listing",
              path: "/trip-listing/:imei",
              meta: { middleware: auth, parent_name: ["trips"] },
              component: () =>
                import(
                  "@/views/modules/trips/sub-screen/SingleTripListing.vue"
                ),
            },
          ]
        : []),
      // Trip Details
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-trip-details.list")
        ? [
            {
              name: "trip-detail",
              path: "/trip-detail/:id",
              meta: {
                middleware: auth,
                parent_name: ["trips", "trip-listing"],
              },
              component: () =>
                import("@/views/modules/trips/sub-screen/TripDetails.vue"),
            },
          ]
        : []),
      // Charge Session
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-charge-sessions.list")
        ? [
            {
              name: "charge_session",
              path: "/charge-session",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/charge-session/Index.vue"),
            },
          ]
        : []),
      // Charge Session List
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-charge-sessions.list")
        ? [
            {
              name: "charge-session-list",
              path: "/charge-session-list/:imei",
              meta: { middleware: auth, parent_name: ["charge_session"] },
              component: () =>
                import(
                  "@/views/modules/charge-session/sub-screen/ChargeSession.vue"
                ),
            },
          ]
        : []),
      // Battery Diagnostics
      ...(Vue.prototype.$admin.hasAccessTo("battery-diagnostics.list")
        ? [
            {
              name: "battery_diagnostics",
              path: "/battery-diagnostics",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/battery-diagnostics/Index.vue"),
            },
          ]
        : []),
      // battery Diagnostic
      // old permission: vehicle-telematics.list
      ...(Vue.prototype.$admin.hasAccessTo("battery-diagnostics.list")
        ? [
            {
              name: "battery_diagnostics_list",
              path: "/battery-diagnostics-list/:imei",
              meta: { middleware: auth, parent_name: ["battery_diagnostics"] },
              component: () =>
                import(
                  "@/views/modules/battery-diagnostics/sub-screen/BatteryDiagnosticsList.vue"
                ),
            },
          ]
        : []),
      // Remote On Off
      ...(Vue.prototype.$admin.hasAccessTo("vehicles.remote")
        ? [
            {
              name: "remote_on_off",
              path: "/vehicle-activity",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/remote-on-off/Index.vue"),
            },
          ]
        : []),

      // Groups
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-groups.list")
        ? [
            {
              name: "groups",
              path: "/groups",
              meta: { middleware: auth },
              component: () => import("@/views/modules/groups/Index.vue"),
            },
          ]
        : []),

      // Vehicle Maintenance Logs
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-maintenance-logs.list")
        ? [
            {
              name: "vehicle_maintenance_logs",
              path: "/vehicle-maintenance-logs",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/vehicle-maintenance/maintenance-logs/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("upcoming-vehicle-maintenance.list")
        ? [
            {
              name: "upcoming_vehicle_maintenance",
              path: "/upcoming-vehicle-maintenance",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/vehicle-maintenance/upcoming-maintenance/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("service-log.list")
        ? [
            {
              name: "vehicle_services_logs",
              path: "/vehicle-services-logs",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/vehicle-maintenance/vehicle-services-logs/Index.vue"
                ),
            },
          ]
        : []),

      // Inventory Management
      ...(Vue.prototype.$admin.hasAccessTo("categories.list")
        ? [
            {
              name: "category",
              path: "/category",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/inventory-management/category/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("parts.list")
        ? [
            {
              name: "parts",
              path: "/parts",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/inventory-management/parts/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("inventory.list")
        ? [
            {
              name: "inventory",
              path: "/inventory",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/inventory-management/inventory/Index.vue"
                ),
            },
          ]
        : []),

      //Modules Screen >

      // Performance
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-comparision.list")
        ? [
            {
              name: "vehicle_comparison",
              path: "/vehicle-comparison",
              meta: { middleware: auth },
              // component: () => import("@/views/dashboard/performance/VehicleComparison.vue"),
              component: () =>
                import("@/views/modules/performance/VehicleComparison.vue"),
            },
          ]
        : []),
      // Fleet Dashboard
      ...(Vue.prototype.$admin.hasAccessTo("dashboard.list")
        ? [
            {
              name: "fleet_transition_dashboard",
              path: "/fleet-transition-dashboard",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/fleet-transition-dashboard/Index.vue"),
            },
          ]
        : []),
      // Fleet Dashboard
      ...(Vue.prototype.$admin.hasAccessTo("driver-comparision.list")
        ? [
            {
              name: "driver_comparison",
              path: "/driver-comparison",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/performance/DriverComparison.vue"),
            },
          ]
        : []),
      // Performance

      // Route Tracking
      ...(Vue.prototype.$admin.hasAccessTo("route-tracking.list")
        ? [
            {
              name: "route-optimization",
              path: "/route-optimization",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/route-optimization/Index.vue"),
            },
          ]
        : []),

      // routes
      ...(Vue.prototype.$admin.hasAccessTo("route-tracking.list")
        ? [
            {
              name: "routes",
              path: "/route",
              meta: { middleware: auth },
              component: () => import("@/views/modules/routes/Index.vue"),
            },
          ]
        : []),
      // Route Listing
      ...(Vue.prototype.$admin.hasAccessTo("routes.list")
        ? [
            {
              name: "route_listing",
              path: "/route-listing",
              meta: { middleware: auth },
              component: () => import("@/views/modules/routing/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("routes.create")
        ? [
            {
              name: "route-create",
              path: "/route-listing-create",
              meta: { middleware: auth, parent_name: ["route-listing"] },
              component: () =>
                import("@/views/modules/routing/sub-screen/RouteCreate.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("routes.edit")
        ? [
            {
              name: "route-edit",
              path: "/route-listing-edit/:id",
              meta: { middleware: auth, parent_name: ["route-listing"] },
              component: () =>
                import("@/views/modules/routing/sub-screen/RouteEdit.vue"),
            },
          ]
        : []),
      // Route Listing
      // Route Planing
      ...(Vue.prototype.$admin.hasAccessTo("route-planning.list")
        ? [
            {
              name: "route_planning",
              path: "/route-planning",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/route-planing/Index.vue"),
            },
            {
              name: "job_route",
              path: "/job-route/:id",
              meta: { middleware: auth, parent_name: ["route-planning"] },
              component: () =>
                // import("@/views/modules/route-planing/sub-screen/JobRoute.vue"),
                import(
                  "@/views/modules/route-planing/sub-screen/GoogleJobRoute.vue"
                ),
            },
            {
              name: "job_route1",
              path: "/job-route1/:id",
              meta: { middleware: auth, parent_name: ["route-planning"] },
              component: () =>
                import("@/views/modules/route-planing/sub-screen/JobRoute.vue"),
            },
          ]
        : []),

      // Route Planing

      ...(Vue.prototype.$admin.hasAccessTo("routes.comparision")
        ? [
            {
              name: "route_comparison",
              path: "/route-comparison",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/route-comparison/Index.vue"),
            },
          ]
        : []),

      // Charging Management
      ...(Vue.prototype.$admin.hasAccessTo("charging-dashboard.list")
        ? [
            {
              name: "charging_dashboard",
              path: "/charging-dashboard",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/charging-dashboard/Index.vue"
                ),
            },
            {
              name: "charging_dashboard_v1",
              path: "/charging-dashboard-v1",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/charging-dashboard-v1/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("charging-dashboard.list")
        ? [
            {
              name: "charger_location",
              path: "/charger-location",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/charger-location/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("charging-sessions.list")
        ? [
            {
              name: "charging_sessions",
              path: "/charging-sessions",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/charging-sessions/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("ocpp-logs.list")
        ? [
            {
              name: "ocpp_logs",
              path: "/ocpp-logs",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/ocpp-logs/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("charging-dashboard.list")
        ? [
            {
              name: "charging_dashboard_detail",
              path: "/charging-dashboard/detail",
              meta: {
                middleware: auth,
                parent_name: ["charging_dashboard"],
              },
              component: () =>
                import(
                  "@/views/modules/charging-management/charging-dashboard/sub-screen/Details.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("operations-troubleshooting.list")
        ? [
            {
              name: "charger_diagnostics",
              path: "/charger-diagnostics",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/operations-troubleshooting/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("operations-troubleshooting.list")
        ? [
            {
              name: "charger_diagnostics_detail",
              path: "/charger-diagnostics/detail",
              meta: {
                middleware: auth,
                parent_name: ["charger_diagnostics"],
              },
              component: () =>
                import(
                  "@/views/modules/charging-management/operations-troubleshooting/sub-screen/Details.vue"
                ),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("financials.list")
        ? [
            {
              name: "financials",
              path: "/financials",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/financials/Index.vue"
                ),
              // "@/views/modules/charging-management/payment-billing/Index.vue"
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("locations.list")
        ? [
            {
              name: "locations",
              path: "/locations",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/locations/Index.vue"
                ),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("rates.list")
        ? [
            {
              name: "rates",
              path: "/rates",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/charging-management/rates/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("charge-stations.list")
        ? [
            {
              name: "charge_stations",
              path: "/charge-stations",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/charge-stations/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("charging-connectors.list")
        ? [
            {
              name: "charge_connectors",
              path: "/charge-connectors",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/charge-stations/ConnectorIndex.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("battery-diagnostics.list")
        ? [
            {
              name: "arrival_dashboard",
              path: "/arrival-dashboard",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/arrival-dashboard/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("sla-dashboard.list")
        ? [
            {
              name: "sla_dashboard",
              path: "/sla-dashboard",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/sla_dashboard/Index.vue"
                ),
            },
            {
              name: "sla_dashboard1",
              path: "/sla-dashboard1",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/sla_dashboard/Index1.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("bookings.list")
        ? [
            {
              name: "bookings",
              path: "/bookings",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/bookings/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("bookings-operator")
        ? [
            {
              name: "bookings_operator",
              path: "/bookings-operator",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/bookings-operator/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("charger-maintenance.list")
        ? [
            {
              name: "charger_maintenance",
              path: "/charger-maintenance",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/charger-maintenance/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("ticket-management-and-reports.list")
        ? [
            {
              name: "ticket_management_and_reports",
              path: "/ticket-management-and-reports",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/ticket-management-and-reports/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("config-management.list")
        ? [
            {
              name: "config_management",
              path: "/config-management",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/config-management/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("audit-logs.list")
        ? [
            {
              name: "user_audit_logs",
              path: "/user-audit-logs",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/audit-logs/Index.vue"
                ),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("users-analytics-dashboard")
        ? [
            {
              name: "users_analytics_dashboard",
              path: "/users-analytics-dashboard",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/users-analytics-dashboard/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("revenue-share.list")
        ? [
            {
              name: "revenue_share",
              path: "/revenue-share",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/revenue-share/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("revenue-sharing.list")
        ? [
            {
              name: "revenue_sharing",
              path: "/revenue-sharing",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/revenue-sharing/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("utilization.list")
        ? [
            {
              name: "utilization",
              path: "/utilization",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/utilization/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("generate-qr-code.list")
        ? [
            {
              name: "generate_qr_code",
              path: "/generate-qr-code",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/generateQRCode/Index.vue"
                ),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("rfid.list")
        ? [
            {
              name: "rfid",
              path: "/rfid",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/charging-management/rfid/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("billing-and-invoices.list")
        ? [
            {
              name: "billing_and_invoices",
              path: "/billing-and-invoices",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/billing-and-invoices/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("severity-and-escalation.list")
        ? [
            {
              name: "severity_and_escalation",
              path: "/severity-and-escalation",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/severity-and-escalation/Index.vue"
                ),
            },
          ]
        : []),
      // ...(Vue.prototype.$admin.hasAccessTo("demo-for-qa")
      //   ? [
      //       {
      //         name: "diagnostics",
      //         path: "/diagnostics",
      //         meta: { middleware: auth },
      //         component: () =>
      //           import(
      //             "@/views/modules/charging-management/diagnostics/Index.vue"
      //           ),
      //       },
      //     ]
      //   : []),
      ...(Vue.prototype.$admin.hasAccessTo(
        "energy-analyzer-and-efficiency.list"
      )
        ? [
            {
              name: "energy_analyzer_and_efficiency",
              path: "/energy-analyzer-and-efficiency",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/energy-analyzer-and-efficiency/Index.vue"
                ),
            },
            {
              name: "energy_analyzer",
              path: "/energy-analyzer",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/energy-analyzer/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("availability-dashboard.list")
        ? [
            {
              name: "availability_dashboard",
              path: "/availability-dashboard",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/availability-dashboard/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("downtime.list")
        ? [
            {
              name: "downtime_list",
              path: "/downtime-list",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/downtime-list/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("firmware.list")
        ? [
            {
              name: "firmware",
              path: "/firmware",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/firmware/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("data-completeness.list")
        ? [
            {
              name: "data_completeness",
              path: "/data-completeness",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/data-completeness/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("demo-for-qa")
        ? [
            {
              name: "payment-checkout",
              path: "/payment-checkout",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/charging-management/payment-checkout/Index.vue"
                ),
            },
          ]
        : []),
      // Charging Management

      // Fuel Management
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-fuel-dashboard.list")
        ? [
            {
              name: "vehicle_fuel_dashboard",
              path: "/vehicle-fuel-dashboard",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/fuel-management/fuel-dashboard/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("fuel-dispenser-dashboard.list")
        ? [
            {
              name: "fuel_dispenser_dashboard",
              path: "/fuel-dispenser-dashboard",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/fuel-management/fuel-dispenser-dashboard/Index.vue"
                ),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("terminals.list")
        ? [
            {
              name: "terminal",
              path: "/terminal",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/fuel-management/terminal/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("fuel-prices.list")
        ? [
            {
              name: "fuel_prices",
              path: "/fuel-prices",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/fuel-management/fuel-prices/Index.vue"),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("fuel-tanks.list")
        ? [
            {
              name: "fuel_tank",
              path: "/fuel-tank",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/fuel-management/fuel-tank/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("vehicle-fuel-sessions.list")
        ? [
            {
              name: "vehicle_fuel_sessions",
              path: "/vehicle-fuel-sessions",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/fuel-management/vehicle-fuel-sessions/Index.vue"
                ),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("dispensers.list")
        ? [
            {
              name: "dispensers",
              path: "/dispensers",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/fuel-management/dispensers/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("dispensers.list")
        ? [
            {
              name: "data_logs",
              path: "/data-logs",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/fuel-management/data-logs/Index.vue"),
            },
            {
              name: "data_logs_create",
              path: "/data-logs-create",
              meta: { middleware: auth, parent_name: ["data_logs"] },
              component: () =>
                import(
                  "@/views/modules/fuel-management/data-logs/sub-screeen/CreateDataLogs.vue"
                ),
            },
            // logs Comparison
            {
              name: "logs_comparison",
              path: "/logs-comparison",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/fuel-management/logs-comparison/Index.vue"
                ),
            },
          ]
        : []),
      // Fuel Management

      // Report
      ...(Vue.prototype.$admin.hasAccessTo("journey-reports.list")
        ? [
            {
              name: "transit_reports",
              path: "/transit-reports",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/reports/transit-reports/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("journey-reports.list")
        ? [
            {
              name: "compliance_reports",
              path: "/compliance-reports",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/reports/compliance-reports/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("journey-reports.list")
        ? [
            {
              name: "journey_reports",
              path: "/journey-reports",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/reports/journey-reports/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("daily-mileage-reports.list")
        ? [
            {
              name: "daily_mileage_reports",
              path: "/daily-mileage-reports",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/reports/daily-mileage-reports/Index.vue"
                ),
            },
          ]
        : []),

      // Report

      // Flespi
      ...(Vue.prototype.$admin.hasAccessTo("flespi-streams.list")
        ? [
            {
              name: "streams",
              path: "/streams",
              meta: { middleware: auth },
              component: () => import("@/views/modules/flespi/Streams.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("flespi-plugins.list")
        ? [
            {
              name: "plugins",
              path: "/plugins",
              meta: { middleware: auth },
              component: () => import("@/views/modules/flespi/Plugins.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("flespi-calcs.list")
        ? [
            {
              name: "calculators",
              path: "/calculators",
              meta: { middleware: auth },
              component: () => import("@/views/modules/flespi/Calculators.vue"),
            },
          ]
        : []),

      // Flespi

      // Pages
      ...(Vue.prototype.$admin.hasAccessTo("roles.list")
        ? [
            {
              name: "roles",
              path: "/roles",
              meta: { middleware: auth },
              component: () => import("@/views/modules/roles/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("roles.list")
        ? [
            {
              name: "product_tiers",
              path: "/product-tiers",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/product-tiers/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("users.list")
        ? [
            {
              name: "users",
              path: "/users",
              meta: { middleware: auth },
              component: () => import("@/views/modules/users/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("driving-staff.list")
        ? [
            {
              name: "driving_staff",
              path: "/driving-staff",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/driving-staff/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("staff-assignment.list")
        ? [
            {
              name: "staff_assignment",
              path: "/staff_assignment",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/staff-assignment/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("oem-customers.list")
        ? [
            {
              name: "oem_customers",
              path: "/oem-customers",
              meta: { middleware: auth },
              component: () => import("@/views/modules/customer/Index"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("oem-clients.list")
        ? [
            {
              name: "oem-clients.index",
              path: "/oem-clients/index",
              meta: { middleware: auth },
              component: () => import("@/views/dashboard/oem-clients/Index"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("iot-device-models.list")
        ? [
            {
              name: "iot_device_providers",
              path: "/iot-device-models",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/iot-device-models/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("charge-stations-assignment.list")
        ? [
            {
              name: "charge_stations_assignment",
              path: "/charge-stations-assignment",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/charge-stations-assignment/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("iot-devices.list")
        ? [
            {
              name: "iot_devices",
              path: "/iot-devices",
              meta: { middleware: auth },
              component: () => import("@/views/modules/iot-devices/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("data-sims.list")
        ? [
            {
              name: "data_sims",
              path: "/data-sims",
              meta: { middleware: auth },
              component: () => import("@/views/modules/data-sims/Index.vue"),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("batteries.list")
        ? [
            {
              name: "batterries",
              path: "/batteries",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/battery-management/Index"),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("oem-b2b.list")
        ? [
            {
              name: "oem_business",
              path: "/oem-business",
              meta: { middleware: auth },
              component: () => import("@/views/modules/oem-business/Index.vue"),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("tenants.list")
        ? [
            {
              name: "tenants_management",
              path: "/tenants-management",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/tenants-management/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("tenant-configurations.list")
        ? [
            {
              name: "tenant_configurations",
              path: "/tenant-configurations",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/tenant-configurations/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("tenant-configurations.list")
        ? [
            {
              name: "tenant_relationship",
              path: "/tenant-relationship",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/tenant-relationship/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("tenant-chargers-assignment.list")
        ? [
            {
              name: "tenant_chargers_assignment",
              path: "/tenant-chargers-assignment",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/tenant-chargers-assignment/Index.vue"),
            },
          ]
        : []),
      ...(Vue.prototype.$admin.hasAccessTo("tenant-configurations.list")
        ? [
            {
              name: "vehicle_assign",
              path: "/vehicle-assign",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/vehicle-assign/Index.vue"),
            },
          ]
        : []),

      // CSO Clients
      ...(Vue.prototype.$admin.hasAccessTo("cso-client.list")
        ? [
            {
              name: "cso_clients",
              path: "/cso-clients",
              meta: { middleware: auth },
              component: () => import("@/views/modules/cso-clients/Index.vue"),
            },
          ]
        : []),
      // CSO Clients

      // Alert and notification
      ...(Vue.prototype.$admin.hasAccessTo("alerts.list")
        ? [
            {
              name: "alerts",
              path: "/alerts",
              meta: { middleware: auth },
              component: () =>
                import(
                  "@/views/modules/alerts-and-notifications/alerts/Index.vue"
                ),
            },
          ]
        : []),
      // this is not Permission based
      {
        name: "notifications",
        path: "/notifications",
        meta: { middleware: auth },
        component: () =>
          import(
            "@/views/modules/alerts-and-notifications/notifications/Index.vue"
          ),
      },

      // ...(Vue.prototype.$admin.hasAccessTo("alerts.list")
      //   ? [
      //       {
      //         name: "notifications",
      //         path: "/notifications",
      //         meta: { middleware: auth },
      //         component: () =>
      //           import(
      //             "@/views/modules/alerts-and-notifications/notifications/Index.vue"
      //           ),
      //       },
      //     ]
      //   : []),

      //  Help and Support

      ...(Vue.prototype.$admin.hasAccessTo("help-support.list")
        ? [
            {
              name: "support_tickets",
              path: "/support-tickets",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/help-and-support/Index.vue"),
            },
          ]
        : []),

      ...(Vue.prototype.$admin.hasAccessTo("order-management.list")
        ? [
            {
              name: "order_management",
              path: "/order-management",
              meta: { middleware: auth },
              component: () =>
                import("@/views/modules/order_management/Index.vue"),
            },
          ]
        : []),
    ],
  },
];

export default routes;
